<template>
  <div>
    <div class="py-8 text-center">
      <img @click="scan" :src="scanicon" :alt="scanicon" class="text-center mx-auto w-16 h-16">
      <div class="text mx-auto text-gray-500">扫码验券</div>
      <div class="px-4 pt-4">
        <form @submit="submit">
          <input v-model="code" @submit="submit" type="text" class="text-base border w-full h-12 text-center rounded text-gray-500" placeholder="请输入要验收的拼团验证码">
        </form>
      </div>
    </div>

    <van-pull-refresh v-model="isfresh" @refresh="onRefresh">
      <van-list
        :loading ="isLoading"
        :finished="finished"
        finished-text=""
        @load="onLoad" >
        <order-info
          class="mb-4"
          v-for="order in orders"
          :key="order.id"
          :order="order" />
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import scanicon from '@/assets/images/scan-icon.png'
import OrderInfo from '@/components/affi/OrderInfo'
import wx from 'weixin-js-sdk'
export default {
  components: {
    OrderInfo
  },
  data () {
    return {
      code: '',
      scanr: '',
      scanicon,
      finished: false,
      isLoading: false,
      isfresh: false,
      page: 1,
      perpage: 10,
      totalpage: 1,
      count: 0,
      orders: []
    }
  },
  computed: {
    wxReady () {
      return this.$store.state.wxReady
    },
    location () {
      return this.$store.state.location
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.gettoken()
    })
  }, // end of beforeRouteUpdate
  created () {
    if (!this.$store.state.wxReady) {
      this.gettoken()
    }
    this.fetch()
  },
  methods: {
    loadings () {
      this.$toast.loading({
        duration: 0
      })
    },
    gettoken () {
      let url = 'https://m.yooshifu.com/groupon.html?'
      let params = {
        params: {
          appurl: url
        }
      }
      this.$http.get(this.$api.wxtoken, params).then(res => {
        let { data, status } = res
        if (status) {
          return this.$toast(data.errmsg)
        }
        this.$store.commit('updateWxToken', data)
        let that = this
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名
          jsApiList: ['scanQRCode', 'getLocation', 'chooseWXPay', 'updateTimelineShareData', 'updateTimelineShareData', 'onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareQZone', 'updateAppMessageShareData'] // 必填，需要使用的JS接口列表
        })
        wx.ready(() => {
          that.getlocation()
          that.$store.commit('updateWxState', true)
        })
      })
    },
    getlocation () {
      // 设定一个超时时间
      let that = this
      wx.getLocation({
        type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: function (res) {
          that.$store.commit('updateLocation', { lon: res.longitude, lat: res.latitude })
          // 如果用户已登录，则更新用户坐标
          if (that.user) {
            let params = { lon: res.longitude, lat: res.latitude }
            that.$http.post(that.$api.locations, { data: params })
          }
        }
      })
    },
    fetch () {
      this.isLoading = true
      let params = {
        page: this.page
      }
      this.$http.get(this.$api.affiorders, { params: params }).then(res => {
        let { status, data, meta } = res
        if (status) {
          return this.$h.handleError(res)
        }
        this.isLoading = false
        this.isfresh = false
        this.page = meta.pagination.current_page
        this.totalpage = meta.pagination.total_pages
        this.perpage = meta.pagination.per_page
        if (meta.pagination.current_page === 1) {
          this.orders = data
        } else {
          for (let i = 0; i < data.length; i++) {
            this.orders.push(data[i])
          }
        }
      })
    }, // end of fetch
    onRefresh () {
      this.page = 1
      this.totalpage = 1
      this.isfresh = true
      this.finished = false
      this.fetch()
    }, // end of onRefresh
    onLoad () {
      if (this.page >= this.totalpage) {
        this.isLoading = false
        this.finished = true
      } else {
        this.page = parseInt(this.page) + 1
        this.fetch()
      }
    }, // end of onLoad
    submit () {
      this.scanr = this.code
      this.scaned()
    }, // end of submit
    scan () {
      // this.scanr = '250675047595'
      // this.scaned()
      this.scanr = ''
      if (!this.wxReady) {
        this.$toast('设备不支持扫描，请在微信环境中使用')
        return false
      }
      let that = this
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          that.scanr = res.resultStr // 当needResult 为 1 时，扫码返回的结果
          that.scaned()
        }
      })
    },
    scaned () {
      if (!this.scanr) {
        return false
      }
      this.loadings()
      let code = btoa(this.scanr)
      this.$http.get(this.$api.scan + '/' + code).then(res => {
        this.$toast.clear()
        let { status, data } = res
        if (status) {
          return this.$h.handleError(res)
        }
        this.$dialog.confirm({
          title: '使用代金券？',
          message: '代金券金额：' + data.amount + ' 元，是否使用？'
        }).then(() => {
          this.loadings()
          let params = { lon: this.location.lon, lat: this.location.lat }
          this.$http.post(this.$api.scan + '/' + code, { data: params }).then(res => {
            this.$toast.clear()
            if (res.status) {
              return this.$h.handleError(res)
            }
            this.code = ''
            this.scanr = ''
            this.$dialog.alert({
              title: '使用代金券成功',
              message: '代金券金额：' + data.amount + ' 元, 已有 ' + data.amount + ' 元即将转到您的微信零钱。'
            }).then(() => {})
          })
        })
      })
      this.$toast.clear()
    } // end of scaned
  } // end of methods
}
</script>
